(function () {
  'use strict';

  function selectedVariant(button) {
    var form = button.closest('form');
    var selector = form && form.querySelector('select.original-selector');
    if (!selector) return null;
    try {
      return JSON.parse(button.dataset.variants).find(function (variant) {
        return String(variant.id) === selector.value;
      }) || null;
    } catch (error) {
      return null;
    }
  }

  function update(button, invalidSelection) {
    var variant = invalidSelection ? null : selectedVariant(button);
    button.dataset.invalidSelection = invalidSelection ? 'true' : 'false';
    button.style.display = variant && variant.available === false ? 'block' : 'none';
  }

  function initialize() {
    document.querySelectorAll('[data-fyl-bis]').forEach(function (button) {
      update(button, button.dataset.invalidSelection === 'true');
    });
  }

  // Delegation also covers product sections replaced by the theme editor.
  if (!window.fylOmnisendBackInStock) {
    window.fylOmnisendBackInStock = true;
    document.addEventListener('change', function (event) {
      if (event.target.name !== 'id') return;
      var form = event.target.closest('form');
      if (!form) return;
      form.querySelectorAll('[data-fyl-bis]').forEach(function (button) {
        // Showcase emits detail:false for an impossible option combination,
        // while leaving the previous variant ID in the original selector.
        update(button, event.detail === false);
      });
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-fyl-bis]');
      if (!button) return;
      event.preventDefault();
      var variant = selectedVariant(button);
      if (!variant || variant.available !== false || button.dataset.invalidSelection === 'true') return;

      // Keep the exact variant URL available to Omnisend, including on a
      // direct visit to a fully sold-out product without a variant query.
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url.href);
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', button.dataset.formId]);
    });
    document.addEventListener('shopify:section:load', initialize);
  }

  initialize();
})();
